import React, { FC } from 'react';
import { AuthorType } from '../../../old/storyblok/authors-context';
import {
  Authors,
  AvatarGroup,
  Avatar,
  Details,
  Name,
  Bio,
} from './AuthorMeta.styles';

const formatNames = (authors: AuthorType[]): string => {
  return authors?.length > 1
    ? authors.map((author) => author.name).join(' & ')
    : authors[0]?.name || '';
};

export interface AuthorMetaProps {
  authors?: AuthorType[];
  showBio?: boolean;
}

const AuthorMeta: FC<AuthorMetaProps> = ({ authors, showBio = false }) => {
  return authors && authors?.length > 0 ? (
    <Authors>
      <AvatarGroup>
        {authors.map((author) => (
          <Avatar
            key={author.uuid}
            mobile={author.avatar}
            tablet={author.avatar}
            desktop={author.avatar}
            alt={author.name}
            loading="eager"
          />
        ))}
      </AvatarGroup>
      <Details>
        <Name>{formatNames(authors)}</Name>
        {authors.length === 1 && showBio && <Bio>{authors[0].description}</Bio>}
      </Details>
    </Authors>
  ) : null;
};

export default AuthorMeta;
